import { render, staticRenderFns } from "./ModalPasswordRecoveryRequest.vue?vue&type=template&id=0029a0c0"
import script from "./ModalPasswordRecoveryRequest.vue?vue&type=script&lang=js"
export * from "./ModalPasswordRecoveryRequest.vue?vue&type=script&lang=js"
import style0 from "./ModalPasswordRecoveryRequest.vue?vue&type=style&index=0&id=0029a0c0&prod&lang=less&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports